// billingData.ts
export interface OrderTransaction {
  id: string;
  date: string; // ISO date string
  orderId: string;
  customer: string;
  items: string;
  grossAmount: number;
  fee: number;
  netAmount: number;
  type: 'order' | 'refund';
}

export interface Payout {
  id: string;
  date: string; // ISO date string
  periodStart: string;
  periodEnd: string;
  amount: number;
  status: 'Paid' | 'Pending' | 'Failed';
}

export interface Summary {
  totalEarnings: number;
  totalPaid: number;
  pendingPayout: number;
  nextPayoutDate: string;
}

export const defaultSummaryData: Summary = {
  totalEarnings: 0,
  totalPaid: 0,
  pendingPayout: 0,
  nextPayoutDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
    .toLocaleDateString('en-GB')
    .replace(/\//g, '-')
};

export const orderTransactions: OrderTransaction[] = [
  {
    id: '1',
    date: '2025-05-01',
    orderId: 'ORD-1001',
    customer: 'Alice Smith',
    items: 'Sandwich x2',
    grossAmount: 12.0,
    fee: 1.2,
    netAmount: 10.8,
    type: 'order',
  },
  {
    id: '2',
    date: '2025-05-02',
    orderId: 'ORD-1002',
    customer: 'Bob Johnson',
    items: 'Salad x1',
    grossAmount: 8.5,
    fee: 0.85,
    netAmount: 7.65,
    type: 'order',
  },
  {
    id: '3',
    date: '2025-05-03',
    orderId: 'ORD-1003',
    customer: 'Carol White',
    items: 'Pasta x1',
    grossAmount: 10.0,
    fee: 1.0,
    netAmount: 9.0,
    type: 'refund',
  },
];
